import React from 'react';
import { ShieldCheck, XCircle, CheckCircle2 } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-stone-50" data-id="element-119">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-t-8 border-emerald-500 text-center mb-16" data-id="element-122">
            <div className="inline-block bg-emerald-100 p-4 rounded-full mb-6" data-id="element-123">
              <ShieldCheck className="w-12 h-12 text-emerald-600" data-id="element-124" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-125">
              Probalo sin riesgo. 7 días de garantía total.
            </h2>
            <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-126">
              Si en los primeros 7 días sentís que no es para vos — por
              cualquier motivo — te devolvemos el 100% de tu dinero. Sin
              preguntas. Sin formularios interminables. Sin vueltas.
            </p>
            <p className="font-serif italic text-emerald-800 font-medium" data-id="element-127">
              Porque tu bienestar primero. Siempre.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-0 md:gap-8 bg-white rounded-2xl overflow-hidden shadow-sm border border-stone-200" data-id="element-128">
            {/* Inaction */}
            <div className="p-8 bg-stone-100/50" data-id="element-129">
              <div className="flex items-center gap-2 mb-6 border-b border-stone-200 pb-4" data-id="element-130">
                <XCircle className="w-6 h-6 text-red-500" data-id="element-131" />
                <h3 className="font-bold text-gray-900" data-id="element-132">Seguir como estás</h3>
              </div>
              <ul className="space-y-4" data-id="element-133">
                {['Seguir probando dietas que no funcionan', 'Sentirte inflamada todos los días', 'No saber qué comer ni por qué', 'Pelear con tu cuerpo indefinidamente'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600" data-id="element-134">
                    <span className="text-red-400 mt-1" data-id="element-135">✕</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Action */}
            <div className="p-8 bg-emerald-50/30" data-id="element-136">
              <div className="flex items-center gap-2 mb-6 border-b border-emerald-100 pb-4" data-id="element-137">
                <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-138" />
                <h3 className="font-bold text-emerald-900" data-id="element-139">
                  Empezar el método hoy
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-140">
                {['Un plan concreto, día por día', 'Empezar a notar cambios desde la primera semana', 'Saber exactamente qué hacer sin adivinar', 'Empezar a sentir que tu cuerpo trabaja con vos'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-800 font-medium" data-id="element-141">
                    <span className="text-emerald-600 mt-1" data-id="element-142">✓</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-143">
            <p className="text-xl font-bold text-gray-900" data-id="element-144">
              Este método te ordena todo de una vez.
            </p>
          </div>
        </div>
      </div>
    </section>;
}